import React from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, hasRoleConflict, isViewer } = useAuth();

  const handleGoHome = () => {
    navigate('/');
  };

  const isVisitorConflict = isViewer && hasRoleConflict;

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" sx={{ fontSize: '6rem', mb: 2 }}>
          403
        </Typography>
        <Typography variant="h4" gutterBottom>
          {isVisitorConflict ? 'Visitor Access Only' : 'Access Denied'}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {isVisitorConflict
            ? 'Your account has the Visitor role assigned alongside a higher-privilege role. Only Visitor access is permitted until the role conflict is resolved by an administrator.'
            : "You don't have permission to access this page."}
        </Typography>

        {user && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Signed in as: {user.username}{user.roles.length > 0 ? ` (${user.roles.join(', ')})` : ''}
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="contained" onClick={handleGoHome}>
            Go Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
